import { motion } from "framer-motion";
import { scrollToSection } from "@/App";
import { useContent } from "@/context/ContentContext";

export default function Hero() {
  const { site, hero, images } = useContent();

  return (
    <section data-testid="hero-section" className="relative h-screen min-h-[640px] overflow-hidden">
      <motion.img
        src={images.hero}
        alt="Il fiume Savio vicino alla trattoria"
        className="absolute inset-0 w-full h-full object-cover"
        initial={{ scale: 1.08 }}
        animate={{ scale: 1 }}
        transition={{ duration: 2.4, ease: [0.22, 1, 0.36, 1] }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-olive-900/70 via-olive-900/20 to-transparent" />
      <div className="relative h-full max-w-7xl mx-auto px-6 lg:px-12 flex flex-col justify-end pb-24 lg:pb-32">
        <motion.span
          data-testid="hero-overline"
          className="text-xs font-semibold tracking-[0.25em] uppercase text-sand-100/90 mb-6 block"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
        >
          {hero.overline}
        </motion.span>
        <motion.h1
          data-testid="hero-title"
          className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter text-sand-50 leading-none max-w-3xl"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          {site.name}
        </motion.h1>
        <motion.p
          data-testid="hero-subtitle"
          className="mt-6 max-w-xl text-base md:text-lg font-light text-sand-100/85 leading-relaxed"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.7 }}
        >
          {hero.subtitle}
        </motion.p>
        <motion.div
          className="mt-10 flex flex-wrap gap-4"
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.9 }}
        >
          <button
            data-testid="hero-cta-scopri"
            onClick={() => scrollToSection("trattoria")}
            className="px-8 py-4 bg-sand-50 text-olive-900 text-xs font-semibold tracking-[0.18em] uppercase transition-colors duration-300 hover:bg-sand-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500"
          >
            Scopri la trattoria
          </button>
          <button
            data-testid="hero-cta-preventivi"
            onClick={() => scrollToSection("preventivi")}
            className="px-8 py-4 border border-sand-50/70 text-sand-50 text-xs font-semibold tracking-[0.18em] uppercase transition-colors duration-300 hover:bg-sand-50 hover:text-olive-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500"
          >
            Preventivi per gruppi
          </button>
        </motion.div>
      </div>
    </section>
  );
}
